import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col items-center justify-center gap-3 rounded-lg border border-gray-200 bg-white p-16"
}
const _hoisted_2 = { class: "text-sm text-gray-500" }
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col items-center justify-center gap-4 rounded-lg border border-gray-200 bg-white p-16"
}
const _hoisted_4 = { class: "text-sm text-red-600" }
const _hoisted_5 = { class: "mb-4 flex flex-wrap items-center justify-between gap-3" }
const _hoisted_6 = { class: "flex flex-wrap items-center gap-1" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex items-center gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Button = _resolveComponent("Button")!
  const _component_FarmToFarmTable = _resolveComponent("FarmToFarmTable")!
  const _component_ExportModal = _resolveComponent("ExportModal")!
  const _component_MainViewCard = _resolveComponent("MainViewCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isPending)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Spinner, { class: "h-10 w-10" }),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('views.farmToFarm.computing')), 1)
        ]))
      : (_ctx.isError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('views.farmToFarm.reportError')), 1),
            _createVNode(_component_Button, {
              variant: "outline",
              size: "sm",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reset')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('views.farmToFarm.startOver')), 1)
              ]),
              _: 1
            })
          ]))
        : (_ctx.report)
          ? (_openBlock(), _createBlock(_component_MainViewCard, {
              key: 2,
              class: "overflow-hidden p-4"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.periods, (period) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: period,
                        type: "button",
                        class: _normalizeClass(["border px-3 py-1.5 text-sm", period === _ctx.selectedPeriod ? 'border-primary-500 bg-dark-gray-200 font-semibold text-primary-700' : 'border-dark-gray-200 bg-white text-dark-gray-600']),
                        onClick: ($event: any) => (_ctx.selectedPeriod = period)
                      }, _toDisplayString(_ctx.periodLabel(period)), 11, _hoisted_7))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_Button, {
                      variant: "outline",
                      size: "sm",
                      class: "whitespace-nowrap",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('reset')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('views.farmToFarm.startOver')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Button, {
                      size: "sm",
                      class: "whitespace-nowrap",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isExportOpen = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('views.farmToFarm.export.button')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_FarmToFarmTable, {
                  report: _ctx.report,
                  period: _ctx.selectedPeriod,
                  "aggregate-label": _ctx.aggregateLabel
                }, null, 8, ["report", "period", "aggregate-label"]),
                _createVNode(_component_ExportModal, {
                  modelValue: _ctx.isExportOpen,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isExportOpen) = $event)),
                  periods: _ctx.report.periods,
                  "current-period-label": _ctx.periodLabel(_ctx.selectedPeriod),
                  "is-working": _ctx.isExporting,
                  onDownload: _ctx.onDownload
                }, null, 8, ["modelValue", "periods", "current-period-label", "is-working", "onDownload"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
  ]))
}